import DownloadButton from "../DownloadButton";
import { capitalizeFirstLetterOfEachWord } from "../../utils/Formatter";
import ProfilePlaceholder from "../../assets/svgIcons/ProfilePlaceholder.svg";
import "../../styles/components/transactionPrintLayouts/POInvoiceLayout.css";

export const JobCardInvoiceLayout = ({
  headDetails,
  itemDetails,
  rowData,
  invoiceTableData,
  selectedReportName,
}) => {
  const path = window.location.pathname.split("/").filter(Boolean);
  const transactionName = selectedReportName || path[1];

  const organizationData = JSON.parse(localStorage.getItem("organisation"));

  const formatDate = (dateStr) => {
    if (!dateStr) return "--";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatInspectionValue = (str) => {
    if (!str || str.trim() === "") return "Pending";
    return "Completed";
  };

  const details = [
    {
      label: "Final Inspection",
      value: formatInspectionValue(headDetails?.final_inspection),
    },
    {
      label: "In-Process Inspection",
      value: formatInspectionValue(headDetails?.in_process_inspection),
    },
    {
      label: "First Piece Inspection",
      value: formatInspectionValue(headDetails?.first_piece_inspection),
    },
  ];

  const purchaseDetails = [
    { label: "JobCard Invoice No", value: headDetails.tran_no },
    {
      label: "JobCard Invoice Date",
      value: formatDate(headDetails.created_at),
    },
  ];

  const notes = [
    "Inspection report / quality certificate must accompany the returned processed material.",
    "All scrap/waste generated during processing must be returned along with the finished goods.",
    "Processing must strictly follow the approved drawing/specification; any deviation requires prior approval.",
  ];

  const formatCompanyAddress = (companyData) => {
    if (!companyData) return "N/A";

    const parts = [
      companyData.address?.trim(),
      companyData.city?.trim(),
    ].filter(Boolean);

    const pin = companyData.pincode ? `- ${companyData.pincode}` : "";

    return parts.length > 0 || pin
      ? `${parts.join(", ")} ${pin}`.trim()
      : "N/A";
  };

  const visibleFields = [...rowData]
    .filter((field) => !field.is_internal_field)
    .reverse();

  return (
    <div className="invoice-container sales-jobcard-layout jobcard-page-container">
      <h2 className="invoice-title" style={{ textAlign: "center" }}>
        {capitalizeFirstLetterOfEachWord(transactionName || "")}
      </h2>

      <div className="invoice-box">
        <div className="invoice-left">
          <div className="invoice-logo-container">
            <img
              src={organizationData.logo_url || ProfilePlaceholder}
              alt="Logo"
              className="invoice-logo-content"
            />
          </div>
          <div>
            <h3 className="invoice-company-name">
              {organizationData.name || "N/A"}
            </h3>
            <p className="invoice-company-address">
              {formatCompanyAddress(organizationData) || "N/A"}
              <br />
              GSTIN: {organizationData.gst_no || "N/A"}
              <br />
              State: {organizationData.state || "N/A"}
            </p>
          </div>
        </div>

        <div className="invoice-right">
          {purchaseDetails.map((item, index) => (
            <div
              key={index}
              className={`purchase-detail ${
                index === 0 ? "border-bottom" : ""
              }`}
            >
              <p className="detail-label">
                <strong>{item.label}:</strong>
              </p>
              <div className="detail-value">{item.value || "N/A"}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="invoice-supplier-details-container jobcard-supplier-details-container">
        <div className="invoice-supplier-section report-header-section">
          <h4 className="invoice-section-title"> Product Name:</h4>
          <span
            className="invoice-section-text report-header-text"
            style={{ fontSize: "12px" }}
          >
            {headDetails?.product_name || "N/A"}
          </span>
        </div>

        <div className="invoice-supplier-section report-header-section">
          <h4 className="invoice-section-title"> Company Name:</h4>
          <span
            className="invoice-section-text report-header-text"
            style={{ fontSize: "12px" }}
          >
            {headDetails?.company_name || "N/A"}
          </span>
        </div>

        <div
          className="invoice-supplier-section report-header-section"
          style={{ borderRightWidth: "0px" }}
        >
          <h4 className="invoice-section-title">Total Quantity:</h4>
          <span
            className="invoice-section-text report-header-text"
            style={{ fontSize: "12px" }}
          >
            {headDetails?.total_quantity || "N/A"}
          </span>
        </div>
      </div>

      <div className="invoice-supplier-details-container report-product-details-container">
        <div
          className="invoice-supplier-section report-header-section"
          style={{
            borderRightWidth: "0px",
            borderBottomWidth: "0px",
          }}
        >
          <h4 className="invoice-section-title">Product Description:</h4>
          <span
            className="invoice-section-text report-header-text"
            style={{ fontSize: "12px", fontWeight: "bolder" }}
          >
            {headDetails?.product_desc || "N/A"}
          </span>
        </div>
      </div>

      <div className="invoice-overflow-x-scroll">
        <table className="invoice-table">
          <thead className="invoice-thead">
            <tr>
              <th className="invoice-th" style={{ borderLeftWidth: "0px" }}>
                No.
              </th>
              {visibleFields.map((field, index) => (
                <th
                  key={index}
                  className="invoice-th"
                  style={
                    index === visibleFields.length - 1
                      ? { borderRightWidth: "0px" }
                      : {}
                  }
                >
                  {field.title || field.field_name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {itemDetails.map((item, index) => (
              <tr key={index}>
                <td className="invoice-td" style={{ borderLeftWidth: "0px" }}>
                  {index + 1}
                </td>
                {[...rowData]
                  .filter((field) => !field.is_internal_field)
                  .reverse()
                  .map((field, idx, arr) => (
                    <td
                      key={idx}
                      className="invoice-td"
                      style={
                        idx === arr.length - 1
                          ? { borderRightWidth: "0px" }
                          : {}
                      }
                    >
                      {item[field.field_name] || "-"}
                    </td>
                  ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="invoice-grid-container">
        <div className="invoice-left-pane details-pane">
          <p className="invoice-section-heading">
            <strong>JobCard Details:</strong>
          </p>
          {details.map((item, index) => (
            <div key={index} className="invoice-detail-row">
              <p className="invoice-detail-label">{item.label}:</p>
              <div className="invoice-detail-value">{item.value || "--"}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="invoice-grid-container no-top-border">
        <div className="invoice-left-pane note-pane">
          <p
            className="invoice-note-heading"
            style={{
              paddingLeft: "16px",
              paddingRight: "16px",
              paddingTop: "16px",
            }}
          >
            <strong>Note: </strong>
          </p>
          <ul className="invoice-note-list">
            {notes.map((note, index) => (
              <li key={index} className="invoice-note-item">
                {note}
              </li>
            ))}
          </ul>
        </div>

        <div className="invoice-right-pane">
          <div className="invoice-footer-signature">
            <p style={{ margin: "0px", fontSize: "13px" }}>
              <strong>For, {organizationData.name}</strong>
            </p>
          </div>
        </div>
      </div>
      <p className="invoice-system-generated-note">
        This is a system-generated document and does not require a signature.
      </p>
      <div className="invoice-buttons" style={{ paddingTop: "40px" }}>
        <DownloadButton
          tableData={invoiceTableData}
          fileName="invoice"
          downloadFormats={["excel", "pdf", "full-page-pdf"]}
          fullPageDownload={true}
          fullPageSelector=".jobcard-page-container"
        />
      </div>
    </div>
  );
};
